const getCurrencySign = (currency: string) => {
  switch (currency) {
    case "usd":
      return "&#36;";
    case "eur":
      return "&#8364;";
    case "jpy":
      return "&#165;";
    case "vnd":
      return "&#8363;";
    case "gbp":
      return "&#163;";
    case "krw":
      return "&#8361;";
    case "sgd":
      return "S&#36;";
    case "aud":
      return "A&#36;";
    case "cad":
      return "C&#36;";
    default:
      return "";
  }
};

export default getCurrencySign;
